import React from "react";
import styled from "styled-components";
import { H1 } from "../../../../Assets/Styles/GlobleStyles/TextStyles";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";

import "slick-carousel/slick/slick.css";
import Slider from "react-slick";
import { getHomeSlider2 } from "../../../../api/axios";
// import { getHomeSlider2 } from "../../../../api/axios";
import useSWR from "swr";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const StyledNextArrow = styled(FaAngleRight)`
  display: block;
  width: 32px;
  height: 40px;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 45%;
  right:0px;
  color: #06476C;
  font-weight: normal;
  z-index: 10;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }

  @media (max-width: 768px) {
    right: -40px;
    width: 28px;
    height: 35px;
  }

  @media (max-width: 480px) {
    right: -30px;
    width: 24px;
    height: 30px;
  }

  @media (max-width: 375px) {
    right: 0px;
    width: 22px;
    height: 28px;
  }
`;

const StyledPrevArrow = styled(FaAngleLeft)`
  display: block;
  width: 32px;
  height: 40px;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 45%;
  left: 0px;
  color: #06476C;
  font-weight: normal;
  z-index: 10;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }

  @media (max-width: 768px) {
    left: -20px;
    width: 28px;
    height: 35px;
  }

  @media (max-width: 480px) {
    left: -15px;
    width: 24px;
    height: 30px;
  }

  @media (max-width: 375px) {
    left:26px;
    width: 22px;
    height: 28px;
  }
`;

function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <StyledNextArrow
      className={className}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <StyledPrevArrow
      className={className}
      onClick={onClick}
    />
  );
}

export default function Slider2() {
  const theme = useTheme();
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
          dots: false,
        },
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
          dots: false,
        },
      },
      {
        breakpoint: 565,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  const { data: slidetwo = {} } = useSWR(
    `getHomeSlider2`,
    async () => {
      try {
        const { data } = await getHomeSlider2();
        return data?.data?.[0];
      } catch (error) {
        console.error("error: ", error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  const logos = [
    { logo: slidetwo?.logo1 },
    { logo: slidetwo?.logo2 },
    { logo: slidetwo?.logo3 },
    // {logo: slidetwo.logo1},
    // {logo: slidetwo.logo2},
    // {logo: slidetwo.logo3},
  ];

  const Title = styled(H1)`
  margin: 0 auto;
  font-weight: 400;
  font-size: 48px;
  text-align: center;
  letter-spacing: 0.02em;
  color: ${theme.palette.text.main};
  line-height: 1.2;
  
  @media (max-width: 1120px) {
    font-size: 42px;
    line-height: 1.3;
    padding-top: 20px;
  }
  
  @media (max-width: 910px) {
    font-size: 38px;
    line-height: 1.3;
    padding-top: 20px;
  }
  
  @media (max-width: 785px) {
    font-size: 34px;
    line-height: 1.3;
  }
  
  @media (max-width: 725px) {
    font-size: 30px;
    line-height: 1.3;
  }
  
  @media (max-width: 680px) {
    font-size: 28px;
    line-height: 1.3;
  }
  
  @media (max-width: 635px) {
    font-size: 26px;
    line-height: 1.3;
  }
  
  @media (max-width: 595px) {
    font-size: 24px;
    line-height: 1.3;
  }
  
  @media (max-width: 550px) {
    font-size: 22px;
    line-height: 1.3;
  }
  
  @media (max-width: 535px) {
    font-size: 20px;
    line-height: 1.3;
  }
  
  @media (max-width: 520px) {
    font-size: 18px;
    line-height: 1.3;
    padding-top: 15px;
  }
`;

  return (
    // grid rows
    <Wrapper>
      {/* row1 */}
      <Title>
        <b>
          Trusted by <Box component="span" sx={{color : `${theme.palette.primary.main}`}}>Leading</Box> Organizations
        </b>
      </Title>

      {/* row2 */}
      <IconWrapper>
        <Slider {...settings}>
          {logos.map((logo, i) => (
            <div key={i}>
              <Image src={logo.logo} />
            </div>
          ))}
        </Slider>
      </IconWrapper>
    </Wrapper>
  );
}
// const ImageWrapper = styled.div`
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   grid-gap: 20px;

//   `;

const Wrapper = styled.div`
  padding: 60px 150px;
  margin: 0 auto;

  @media (max-width: 1040px) {
    padding: 60px 100px;
  }
  
  @media (max-width: 830px) {
    padding: 40px 50px 20px;
  }
  
  @media (max-width: 768px) {
    padding: 30px 30px 15px;
  }
  
  @media (max-width: 480px) {
    padding: 25px 20px 10px;
  }
  
  @media (max-width: 375px) {
    padding: 20px 15px 8px;
  }
  
  @media (max-width: 320px) {
    padding: 15px 10px 5px;
  }
`;

const IconWrapper = styled.div`
  margin: 0 auto;
  padding-top: 50px;
  
  @media (max-width: 768px) {
    padding-top: 40px;
  }
  
  @media (max-width: 480px) {
    padding-top: 30px;
  }
  
  @media (max-width: 375px) {
    padding-top: 25px;
  }
  
  @media (max-width: 320px) {
    padding-top: 20px;
  }
`;

const Image = styled.img`
  max-width: 100vw;
  width: auto;
  height: 100px;
  margin: 0 auto;
  opacity: 1;
  animation: fadein 2s;
  
  @keyframes fadein {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  @media (max-width: 1024px) {
    height: 90px;
  }
  
  @media (max-width: 820px) {
    max-width: 20vw;
    height: 80px;
  }
  
  @media (max-width: 740px) {
    max-width: 25vw;
    height: 70px;
  }
  
  @media (max-width: 555px) {
    max-width: 40vw;
    height: 60px;
  }
  
  @media (max-width: 480px) {
    max-width: 50vw;
  }
  
  @media (max-width: 375px) {
    max-width: 60vw;
  }
  
  @media (max-width: 320px) {
    max-width: 70vw;
  }
`;
